// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class Users extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "Users";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      username: null,
      userType: null,
      firstName: null,
      lastName: null,
      email: null,
      status: null,
      avatar: null,
      dob: null,
      mobile: null,
      companyId: null,
      jobTitle: null,
      gender: null,
      addLine1: null,
      addLine2: null,
      postCode: null,
      city: null,
      state: null,
      country: null,
      twitter: null,
      facebook: null,
      instagram: null,
      linkedin: null,
      createdAt: null,
      coachingSurveyDate:null,
      updatedAt: null,
      lang:null,
      flag:null,
      isVerified: null,
      verifyToken: null,
      verifyExpires: null,
      verifyChanges: null,
      resetToken: null,
      resetExpires: null
    };
  }
}
const servicePath = "users";
const servicePlugin = makeServicePlugin({
  Model: Users,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
